const PIXEL_IDS = ['4370383059953672', '1855919328424207']

let initialized = false
let pageViewTracked = false
const firedEvents = new Set<string>()

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function initFbPixel(): void {
  if (initialized) return
  if (typeof window === 'undefined') return
  initialized = true

  // 1. Official Meta Pixel base code (exact replica of their snippet)
  !(function (f: any, b: any, e: any, v: any) {
    let n: any, t: any, s: any
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = true
    t.src = v
    s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  // 2. Initialize ALL pixels
  PIXEL_IDS.forEach((id) => {
    window.fbq('init', id)
  })

  // 3. Fire PageView exactly once for all pixels
  if (!pageViewTracked) {
    pageViewTracked = true
    window.fbq('track', 'PageView')
  }

  // 4. Add noscript image fallbacks for both pixels
  PIXEL_IDS.forEach((id) => {
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${id}&ev=PageView&noscript=1`
    img.alt = ''
    document.body.appendChild(img)
  })
}

export function trackPageView(): void {
  if (pageViewTracked) return
  if (typeof window !== 'undefined' && window.fbq) {
    pageViewTracked = true
    window.fbq('track', 'PageView')
  }
}

export function trackEvent(
  eventName: string,
  params?: Record<string, any>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return

  // Generate a dedup key from event name + params to prevent identical duplicate fires
  const dedupKey = `${eventName}_${JSON.stringify(params || {})}`

  if (firedEvents.has(dedupKey)) return
  firedEvents.add(dedupKey)

  // Clear the dedup key after 3 seconds so the same event can fire again
  // on a genuinely new user action (e.g., returning to page later)
  setTimeout(() => firedEvents.delete(dedupKey), 3000)

  window.fbq('track', eventName, params)
}
